import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { RestoreAgentSetup } from './RestoreAgentSetup'

/**
 * "Restore agent" from the profile icon (Andrew, 16 Oct 2026): what this laptop needs to run
 * restores, in order. Its contents mount only while it is open, so nothing talks to the plug-in,
 * the daemon or the back end from any other page.
 */
export function RestoreAgentDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
    const { t } = useTranslation()
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-h-[90vh] w-[calc(100vw-2rem)] max-w-3xl overflow-y-auto overflow-x-hidden" data-testid="restore-agent-dialog">
                <DialogHeader>
                    <DialogTitle>{t('restoreSetup.title', 'Set up this laptop for restores')}</DialogTitle>
                    <DialogDescription>{t('restoreSetup.description', 'Two things go on this laptop: the browser plug-in and the VaultSentinel package. Each step below ticks itself when it is done; come back to this tab after each one.')}</DialogDescription>
                </DialogHeader>
                {open && <RestoreAgentSetup />}
            </DialogContent>
        </Dialog>
    )
}
